// routes
export const ROOT_ROUTE = '/';
export const PODCAST_ROOT_ROUTE = '/podcasts';
export const PODCAST_ROUTE = '/podcasts/:podcastsId';

export const INIT = {
	START: '--- INIT.START ---',
	SUCCESS: '--- INIT.SUCCESS ---',
	FAIL: '--- INIT.FAIL ---',
};
export const SET_POP_UP = 'SET_POP_UP';

// others:
export const IS_DEVEL = process.env.NODE_ENV === 'development';
export const IMAGES_PATH = 'assets/client/images';

export const SHARE_CONSTANTS = {
	WHATSAPP: 'WhatsApp',
	TWITTER: 'Twitter',
	MAIL: 'Mail',
	FACEBOOK: 'Facebook',
};

export const MAIL_TO_ANALYTICS = {
	FOOTER: 'Article Bottom',
	ASIDE_STICKY: 'Side Sticky',
};

export const AUDIO_PLAYER_ANALYTICS = {
	START: 'Start',
	PLAYING: 'Playing',
	SKIP_FORWARDS: 'Skip Forwards',
	SKIP_BACKWARDS: 'Skip Backwards',
	PAUSE: 'Pause',
	UNPAUSE: 'Resume',
	REPLAY: 'Replay',
};
